const marketConstants = {
  maxCards: 5,
  marketAction: { changePrice: "changePrice", list: "list" },
  sliderBreakpoints: {
    0: {
      slidesPerView: 1,
    },
    500: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 3,
    },
    991: {
      slidesPerView: 5,
    },
  },
  sliderAutoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  collection: {
    cyko: "cykokobattle",
    gnome: "gnomeseries1",
    complex: "complexserie",
    world: "gnocityworld",
    food: "gnocityfood1",
  },
};

export default marketConstants;
